import { ShadLineChart } from "../ShadLineChart";
import { useState, useMemo } from "react";

const chartConfig = {
    leaving: { label: "יוצאים", color: "hsl(var(--chart-1))" },
    entering: { label: "נכנסים", color: "hsl(var(--chart-2))" },
};

const AtarimLinechart = ({ data, deviceNames, lineDeviceName, setLineDeviceName, occupancyLineDataByDuration }) => {
    const [timeRange, setTimeRange] = useState("24h");

    // Memoize the filtered data based on timeRange and data
    const filteredData = useMemo(() => {
        if (!data || data.length === 0) return [];
        const referenceDate = new Date(data[data.length - 1].date);

        const hoursToSubtract = {
            "8h": 8,
            "24h": 24,
            "48h": 48,
            "3d": 72,
            "1w": 168,
        }[timeRange] || 168;

        const startDate = new Date(referenceDate);
        startDate.setHours(referenceDate.getHours() - hoursToSubtract);

        return data.filter((item) => new Date(item.date) >= startDate);
    }, [timeRange, data]);
    
    const filterDayOptions = [
        {value: "8h",
            filterDayOptionComponent:<>
            <div>שעות אחרונות</div>
            <div>8</div>
        </>},
        {value: "24h",
            filterDayOptionComponent:<>
            <div>שעות אחרונות</div>
            <div>24</div>
        </>},
        {value: "48h",
            filterDayOptionComponent:<>
            <div>שעות אחרונות</div>
            <div>48</div>
        </>},
        {value: "3d",
            filterDayOptionComponent:<>
            <div>ימים אחרונים</div>
            <div>3</div>
        </>},
        {value: "1w",
            filterDayOptionComponent:<>
            <div>שבוע חולף</div>
        </>},
    ];

    return (
        <ShadLineChart
            data={data}
            deviceNames={deviceNames}
            lineDeviceName={lineDeviceName}
            setLineDeviceName={setLineDeviceName}
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            filterDayOptions={filterDayOptions}
            filteredData={filteredData}
            chartDescription={`סך כל האנשים שנכנסו ויצאו ב ${timeRange.slice(0, -1)} ${timeRange.substring(timeRange.length - 1) === "h" ? "שעות" : timeRange.substring(timeRange.length - 1) === "d" ? "ימים" : "שבוע"} האחרונות`}
            chartConfig={chartConfig}
        />
    );
};

export default AtarimLinechart;